import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import expertProfileQuery from './query.graphql';

const ExpertProfile = loadable(
  () => import(/* webpackChunkName: "expert" */ './profile'),
  {
    fallback: <Loader />,
  }
);

ExpertProfile.graphQL = expertProfileQuery;

ExpertProfile.variables = ({ slug }) => ({
  slug,
});

export default ExpertProfile;
